module.exports = __webpack_public_path__ + "static/media/user.bec850c4.svg";